import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=b0331102&"
import script from "./submenu.vue?vue&type=script&lang=js&"
export * from "./submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0331102')) {
      api.createRecord('b0331102', component.options)
    } else {
      api.reload('b0331102', component.options)
    }
    module.hot.accept("./submenu.vue?vue&type=template&id=b0331102&", function () {
      api.rerender('b0331102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/submenu.vue"
export default component.exports